module.exports = __webpack_public_path__ + "img/logo-ing.79129fa0.png";